import * as React from "react"
import {Box} from "@mui/material";
import {ButtonSeeker, IconSeeker, ModalSeeker} from "@ui-seeker/core";

import {useRawMatcherImageComparisonNavigator} from "../../@hooks";
import {rawMatcherImageComparatorModalData} from "../../@signals";
import RawMatcherImageComparisonModalContainer from "./Container";
import RawMatcherImageComparisonModalCounter from "./Counter";
import RawMatcherImageComparisonModalArrow from "./Arrow";


export default function RawMatcherImageComparisonModal({  brandOptions=[], setSelectedSKU, saveMapping  }) {
	const { isOpen, numOptions, localIndex, handleNavigateLeft, handleNavigateRight } = useRawMatcherImageComparisonNavigator(brandOptions, setSelectedSKU)

	return <ModalSeeker
		hideActions
		isOpen={isOpen}
		title="Image Comparison"
		controller={() => rawMatcherImageComparatorModalData.value = {}}
		containerProps={{ fullScreen: true }}
	>
		<Box
			maxWidth={1}
			mx="auto"
			p={2}
		>
			<Box display="flex" flexDirection="column" gap={2}>
				<Box display="flex" alignItems="center" justifyContent="space-between" width={1}>
					<RawMatcherImageComparisonModalCounter
						numOptions={numOptions}
						localIndex={localIndex}
					/>

					<ButtonSeeker
						color="success"
						startIcon={<IconSeeker icon="badge-check" />}
						onClick={() => {
							saveMapping?.()
							rawMatcherImageComparatorModalData.value = {}
						}}
					>
						Validate
					</ButtonSeeker>
				</Box>


				<Box
					display="flex"
					gap={2}
					alignItems="stretch"
					justifyContent="center"
					height="75vh"
					sx={{ position: 'relative' }}
				>
					<RawMatcherImageComparisonModalArrow
						orientation="left"
						brandOptionsLength={numOptions}
						localIndex={localIndex}
						onNavigate={handleNavigateLeft}
					/>
					<RawMatcherImageComparisonModalArrow
						orientation="right"
						brandOptionsLength={numOptions}
						localIndex={localIndex}
						onNavigate={handleNavigateRight}
					/>
					<RawMatcherImageComparisonModalContainer
						fullURL={rawMatcherImageComparatorModalData.value?.fullUrlLeft}
						url={rawMatcherImageComparatorModalData.value.urlLeft}
						label="Target (Product)"
						labelColor="default"
						productName={rawMatcherImageComparatorModalData.value?.productName}
					/>
					<RawMatcherImageComparisonModalContainer
						fullURL={rawMatcherImageComparatorModalData.value?.fullUrlRight}
						url={rawMatcherImageComparatorModalData.value.urlRight}
						label="Selected (SKU)"
						labelColor="primary"
						productName={rawMatcherImageComparatorModalData.value?.candidateName}
					/>
				</Box>
			</Box>
		</Box>
	</ModalSeeker>
}
